import axios, {AxiosResponse} from 'axios'
import {ID} from '../../../../../../_metronic/helpers'
import {LovData, Data, QueryResponse, CampaignDetailResponse} from './_models'

const API_URL = process.env.REACT_APP_THEME_API_URL
const URL = `${API_URL}/call/campaign`
const URL_LOV = `${API_URL}/lov`
const GET_URL = `${API_URL}/call/campaign/query`

const getData = (query: string): Promise<QueryResponse> => {
  return axios.get(`${GET_URL}?${query}`).then((d: AxiosResponse<QueryResponse>) => d.data)
}

const getDataById = (id: string): Promise<CampaignDetailResponse> => {
  return axios.get(`${URL}/${id}`).then((res: AxiosResponse<CampaignDetailResponse>) => res.data)
}

const fetchData = (tableCodes: string[]): Promise<LovData> => {
  return axios
    .post(`${URL_LOV}/multidata`, { tableCodes })
    .then((res) => res.data)
}

const createData = (data: Data): Promise<Data | undefined> => {
  return axios
    .post(URL, data)
    .then((response: AxiosResponse<Data>) => response.data)
}

const updateData = (data: Data, id: string): Promise<Data | undefined> => {
  return axios
    .put(`${URL}/${id}`, data)
    .then((response: AxiosResponse<Data>) => response.data)
}

const deleteData = (dataId: string): Promise<void> => {
  return axios.delete(`${URL}/${dataId}`).then(() => {})
}

const deleteSelectedData = (dataIds: Array<ID>): Promise<void> => {
  const requests = dataIds.map((id) => axios.delete(`${URL}/${id}`))
  return axios.all(requests).then(() => {})
}

const importLeads = (campaignId: string, leads: any[]): Promise<any> => {
  return axios
    .post(`${URL}/${campaignId}/import-leads`, leads)
    .then((response) => response.data)
}

const getSubmissionsByCampaign = (campaignId: string, query: string): Promise<any> => {
  return axios
    .get(`${URL}/${campaignId}/submissions?${query}`)
    .then((res: AxiosResponse<any>) => res.data)
}

const getReport = (campaignId: string): Promise<any> => {
  return axios
    .get(`${URL}/${campaignId}/report`)
    .then((res: AxiosResponse<any>) => res.data)
}

const getDashboard = (campaignId: string, startDate?: string, endDate?: string): Promise<any> => {
  let query = '';
  if (startDate && endDate) {
    query = `?startDate=${startDate}&endDate=${endDate}`;
  }
  return axios
    .get(`${URL}/${campaignId}/dashboard-summary${query}`)
    .then((res: AxiosResponse<any>) => res.data)
}

const getAgent = async () => {
  return axios
    .get(`${API_URL}/roles/6/users`)
    .then((res) => res.data)
}

const getAssignedAgents = async (campaignId: string) => {
  return axios
    .get(`${URL}/${campaignId}/assigned-agents`)
    .then((res: AxiosResponse<any>) => res.data)
}

const assignAgent = (campaignId: string, agentId: string) => {
  return axios.post(`${URL}/${campaignId}/assign-agent`, { agentId })
}

const removeAgent = (campaignId: string, agentId: string) => {
  return axios.delete(`${URL}/${campaignId}/remove-agent/${agentId}`)
}

const updateAgentQuotas = (campaignId: string, payload: any[]) => {
  return axios.post(`${URL}/${campaignId}/update-quotas`, payload)
}

const saveOutboundCall = (payload: {
  campaignId: string,
  submissionId: string,
  welcomeStatusCall: string,
  welcomeResultCall: string,
  welcomeStatus: string,
  productKnowledge: string,
  notes: string
}) => {
  return axios.post(`${URL}/save-result`, payload)
}

const triggerCallInitiate = (campaignId: string, leadId:  string, fieldName: string) => {
  return axios.post(`${URL}/initiate-call`, {
    campaignId: campaignId,
    submissionId: leadId,
    fieldName: fieldName,
    timestamp: new Date().toISOString() 
  })
}

const getWelcomeStatusCall = async () => {
  return axios
    .get(`${URL}/wscdata`)
    .then((res: AxiosResponse<any>) => res)
}

const getWelcomeResultCall = async () => {
  return axios
    .get(`${URL}/wrcdata`)
    .then((res: AxiosResponse<any>) => res)
}

const getWelcomeStatus = async () => {
  return axios
    .get(`${URL}/wsdata`)
    .then((res: AxiosResponse<any>) => res)
}
const getWelcomeProductKnowledge = async () => {
  return axios
    .get(`${URL}/wpkdata`)
    .then((res: AxiosResponse<any>) => res)
}


export {
  getData, 
  deleteData, 
  deleteSelectedData,
  getDataById, 
  createData, 
  updateData, 
  fetchData,
  importLeads,
  getSubmissionsByCampaign,
  getAgent,
  getAssignedAgents,
  assignAgent,
  removeAgent,
  updateAgentQuotas,
  saveOutboundCall,
  triggerCallInitiate,
  getReport,
  getWelcomeStatusCall,
  getWelcomeResultCall,
  getWelcomeStatus,
  getWelcomeProductKnowledge,
  getDashboard
}